import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 11px;
  left: 0;
  opacity: 0.5;
  text-transform: uppercase;
`;
